<template>
  <v-dialog v-model="dialog" width="1220px">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Chi tiết kiểm hàng theo đơn hàng nhập
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="() => (dialog = false)">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mb-6" />
      <v-card-text>
        <div class="d-flex justify-center" :style="{ width: '100%', overflow: 'auto' }">
          <TableListProducts
            class="content"
            :importOrderId="importOrderId"
            @onSelected="isUpdate = true"
            @offSelected="isUpdate = false"
            @refresh="() => initData(importOrderId)"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import TableListProducts from '../../modules/detail-audit-product/TableListProducts.vue'
import { get } from 'lodash'
export default {
  components: { TableListProducts },
  data() {
    return {
      dialog: false,
      importOrderId: ''
    }
  },
  methods: {
    ...mapActions({
      getImportDeliveryProduct: 'auditProducts/getImportDeliveryProduct',
      countImportDeliveryProduct: 'auditProducts/countImportDeliveryProduct',
      getStats: 'auditProducts/getStats'
    }),
    async openDialog(item) {
      if (item) {
        this.importOrderId = get(item, '_id', '')
        this.dialog = true
        await this.initData(get(item, '_id', ''))
      }
    },
    closeDialog() {
      this.dialog = false
    },
    async initData(id) {
      try {
        this.loading = true
        await this.getImportDeliveryProduct({
          importCheck: this.$route.params.id,
          _start: 0,
          _limit: 5,
          productModel: id
        })
        await this.countImportDeliveryProduct({ importCheck: this.$route.params.id, productModel: this.importOrderId })
        await this.getStats({ type: 'detail', importCheck: this.$route.params.id, productModel: this.importOrderId })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  max-height: 500px;
  overflow-y: auto;
}
</style>
